import { FormattedMessage } from 'react-intl'
import { SummaryRow, Tag } from 'ui'
import { useNumbers } from 'ui/components/utils/useNumbers'
import { PercentualShipping } from '../../../../../typings'
import styles from '../styles'
import { ReviewProps } from './constants'
import { messages } from './messages'

type Props = ReviewProps & {
  config: PercentualShipping
}

export function PercentualShippingReview(props: Props) {
  const { config } = props
  const { formatPercentual } = useNumbers()

  return (
    <SummaryRow.Value className={styles.flexRow}>
      <FormattedMessage
        {...messages.percentualShipping}
        values={{
          tag: (content) => <Tag>{content}</Tag>,
          discount: formatPercentual(config.value),
        }}
      />
    </SummaryRow.Value>
  )
}
